import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const getPersonaFormValidation = (name: string) => {
  const message = `${name} is required`;
  return z.string({ required_error: message }).nonempty({ message });
};

export const PERSONA_FORM_VALIDATION_SCHEMA = zodResolver(
  z.object({
    name: getPersonaFormValidation("Name"),
    grade: z.coerce
      .number({
        required_error: "Grade is required",
        invalid_type_error: "Grade must be a number",
      })
      .refine((val) => [10, 11, 12].includes(val), {
        message: "Grade must be 10, 11, or 12",
      }),
    profileType: getPersonaFormValidation("Profile Type"),
    interests: getPersonaFormValidation("Interests"),
  }),
);

export const GRADE_OPTIONS = [
  { label: "10", value: 10 },
  { label: "11", value: 11 },
  { label: "12", value: 12 },
];

